// Where the frontend is running: browser, or the Tauri desktop shell (macOS / Windows).
export function isDesktop(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

export function platformName(): 'macos' | 'windows' | 'web' {
  if (!isDesktop()) return 'web';
  return /Windows/i.test(navigator.userAgent) ? 'windows' : 'macos';
}
